import React from 'react';
import { X, Mail, Phone, Clock } from 'lucide-react';
interface ReportIssueModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ReportIssueModal({
  isOpen,
  onClose
}: ReportIssueModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-322">
      <div className="bg-white rounded-xl shadow-xl max-w-lg w-full" data-id="element-323">
        <div className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between rounded-t-xl" data-id="element-324">
          <h2 className="text-xl font-semibold text-gray-900" data-id="element-325">Contact Us</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-326">
            <X className="w-5 h-5" data-id="element-327" />
          </button>
        </div>

        <div className="p-6 space-y-6" data-id="element-328">
          <p className="text-gray-700" data-id="element-329">
            For any issues with bookings, maintenance required for equipment,
            feedback, or suggestions, please contact us directly:
          </p>

          <div className="space-y-4" data-id="element-330">
            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg" data-id="element-331">
              <Mail className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-332" />
              <div data-id="element-333">
                <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-334">Email</p>
                <a href="mailto:agplastic.SDRC@gmail.com" className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-335">
                  agplastic.SDRC@gmail.com
                </a>
              </div>
            </div>

            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg" data-id="element-336">
              <Phone className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-337" />
              <div data-id="element-338">
                <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-339">Phone</p>
                <div className="space-y-1" data-id="element-340">
                  <div data-id="element-341">
                    <p className="text-xs text-gray-500" data-id="element-342">
                      Council Stanthorpe Office
                    </p>
                    <a href="tel:1300697372" className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-343">
                      1300 697 372
                    </a>
                  </div>
                  <div data-id="element-344">
                    <p className="text-xs text-gray-500" data-id="element-345">RM Consulting Group</p>
                    <a href="tel:0451982442" className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-346">
                      0451 982 442
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg" data-id="element-347">
              <Clock className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-348" />
              <div data-id="element-349">
                <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-350">
                  Contact Hours
                </p>
                <p className="text-gray-700" data-id="element-351">
                  Monday - Friday: 9:00 AM - 5:00 PM
                </p>
              </div>
            </div>
          </div>

          <div className="pt-4 border-t border-gray-200" data-id="element-352">
            <button onClick={onClose} className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors" data-id="element-353">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>;
}